import { render } from "./BtnDemo.vue?vue&type=template&id=6b3effb6&scoped=true&ts=true"
import script from "./BtnDemo.vue?vue&type=script&lang=ts"
export * from "./BtnDemo.vue?vue&type=script&lang=ts"

import "./BtnDemo.vue?vue&type=style&index=0&id=6b3effb6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3effb6"]])

export default __exports__